import { render } from "./SubHeaderConfig.vue?vue&type=template&id=3ba11915&scoped=true"
import script from "./SubHeaderConfig.vue?vue&type=script&lang=js"
export * from "./SubHeaderConfig.vue?vue&type=script&lang=js"

import "./SubHeaderConfig.vue?vue&type=style&index=0&id=3ba11915&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ba11915"

export default script